import { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { readPendingWipayPayment, submitWipayPayload } from "../lib/wipay";

export default function WipayRedirectPage() {
  const submittedRef = useRef(false);
  const [payload] = useState(() => readPendingWipayPayment());
  const [countdown, setCountdown] = useState(2);
  const fieldEntries = useMemo(() => (payload ? Object.entries(payload.fields) : []), [payload]);

  useEffect(() => {
    if (!payload || submittedRef.current) return;

    const interval = window.setInterval(() => {
      setCountdown((current) => Math.max(0, current - 1));
    }, 1000);

    const timeout = window.setTimeout(() => {
      submittedRef.current = true;
      submitWipayPayload(payload);
    }, 900);

    return () => {
      window.clearInterval(interval);
      window.clearTimeout(timeout);
    };
  }, [payload]);

  if (!payload) {
    return (
      <section className="grid min-h-[70vh] place-items-center bg-[#f5f8ff] px-5 py-20">
        <div className="max-w-[620px] rounded-[14px] bg-white p-8 text-center shadow-[0_22px_70px_rgba(6,56,111,0.14)]">
          <h1 className="text-[32px] font-extrabold text-[#071746]">Payment session expired</h1>
          <p className="mt-3 text-[#4d5b7c]">Please return to the booking form and start the payment again.</p>
          <Link to="/book" className="mt-7 inline-flex h-12 items-center justify-center rounded-[10px] bg-[#0052ff] px-7 font-bold text-white">
            Back to Booking
          </Link>
        </div>
      </section>
    );
  }

  return (
    <section className="grid min-h-[70vh] place-items-center bg-[#f5f8ff] px-5 py-20">
      <div className="w-full max-w-[680px] rounded-[14px] bg-white p-8 text-center shadow-[0_22px_70px_rgba(6,56,111,0.14)] md:p-12">
        <div className="mx-auto grid h-20 w-20 place-items-center rounded-full bg-[#edf4ff] text-[#0052ff]">
          <Loader2 className="h-10 w-10 animate-spin" />
        </div>
        <h1 className="mt-7 text-[34px] font-extrabold leading-tight text-[#071746] md:text-[44px]">
          Sending you to WiPay
        </h1>
        <p className="mx-auto mt-4 max-w-[520px] text-[17px] leading-relaxed text-[#4d5b7c]">
          Please wait while we open the secure WiPay checkout. Do not refresh or press back.
        </p>
        <p className="mt-4 text-sm font-semibold text-[#06386f]">
          Redirecting in {countdown}...
        </p>

        <form method="POST" action={payload.endpoint} className="hidden" aria-hidden="true">
          {fieldEntries.map(([name, value]) => (
            <input key={name} type="hidden" name={name} value={value} readOnly />
          ))}
        </form>
      </div>
    </section>
  );
}
